import { Box } from "@mui/material";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { icons } from "../../../../../stack/environment/icons/iconExport";

export const EmptyState = ({ height, width }) => {
  return (
    <Box
      sx={{
        height,
        width,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <SvgToIcon
        IconLogo={icons.EmptyPostureTrendIcon}
        style={{
          width: "90%",
          height: "90%",
          color: "transparent",
        }}
      />
    </Box>
  );
};
